import type { RateFinderComponentProps } from './RateFinderComponent';

export const RateFinderComponent = {
    MountAsync: async (target: HTMLElement, props: RateFinderComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { RateFinderComponent } = await import('./RateFinderComponent');
        return await mountReactComponentAsync(target, RateFinderComponent, props);
    }
};